document.addEventListener('alpine:init', function () {
  Alpine.data('ctrAccordionImg', function (config) {
    return {
      openIndex: config.openIndex != null ? config.openIndex : 0,
      toggle: function (index) {
        this.openIndex = this.openIndex === index ? -1 : index;
      },
      isOpen: function (index) {
        return this.openIndex === index;
      },
    };
  });
});
